import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-black">
      <div className="noise-overlay" />
      
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-[#262626]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex justify-between items-center">
          <Link to="/" className="font-heading text-xl font-bold tracking-tight text-[#C9A84C]">
            SAC CITY SHINE
          </Link>
          <Link to="/" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Link>
        </div>
      </nav>

      <div className="pt-24 pb-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-8" data-testid="terms-title">
            Terms and Conditions
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-8 text-gray-300">
            <p>
              By booking services with Sac City Shine, you agree to the following terms.
            </p>

            <p>
              Appointments are scheduled based on availability and may be rescheduled due to weather or operational conditions.
            </p>

            <div>
              <h2 className="font-heading text-lg font-bold text-white mb-3">SMS Messaging Terms</h2>
              <p className="mb-3">
                By providing your phone number and opting in, you consent to receive SMS text messages from Sac City Shine. These messages may include appointment confirmations, reminders, updates, deposit/payment links, and customer support communications.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-lg font-bold text-white mb-3">Message Frequency</h2>
              <p>
                Message frequency varies based on your booking activity and appointment status. You may receive multiple messages related to a single booking (e.g., confirmation, reminder, payment link).
              </p>
            </div>

            <div>
              <h2 className="font-heading text-lg font-bold text-white mb-3">Message and Data Rates</h2>
              <p>
                Message and data rates may apply depending on your mobile carrier and plan. Sac City Shine is not responsible for any charges from your wireless provider.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-lg font-bold text-white mb-3">Opt-Out / STOP</h2>
              <p>
                You may opt out of receiving SMS messages at any time by replying <span className="text-white font-medium">STOP</span> to any message from Sac City Shine. After opting out, you will receive a final confirmation message and no further SMS messages will be sent unless you re-subscribe.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-lg font-bold text-white mb-3">Help / Support</h2>
              <p>
                For assistance with SMS messaging, reply <span className="text-white font-medium">HELP</span> to any message or contact Sac City Shine directly through our website.
              </p>
            </div>

            <p>
              Sac City Shine reserves the right to refuse service when necessary.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 px-6 md:px-12 lg:px-24 bg-black border-t border-[#262626]">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© {new Date().getFullYear()} Sac City Shine. Sacramento, CA.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-white text-sm transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
